import React, { useState } from "react";
import { Modal, List } from "antd";
import { changeDefaultRole } from "apis/admin";
import { loginRolePage } from "pages/myutils/user";
import { showMessage } from "utils";
import cookies from "js-cookie";

const AlertFn2 = ({ visible, onClose, dataSource }) => {
  const [roleIds, setRoleId] = useState(dataSource.defaultRole);
  const changeDeRole = (e, roleId) => {
    e.stopPropagation();
    changeDefaultRole(roleId).then(res => {
      if (res) {
        setRoleId(roleId);
        showMessage("success", "设置成功");
      }
    });
  };
  return (
    <Modal
      title="请选择使用角色"
      onClose={onClose}
      onCancel={onClose}
      visible={visible}
      footer={false}
    >
      <List
        dataSource={dataSource.adminRoles}
        renderItem={item => (
          <List.Item>
            <a
              style={{ display: "inline-block", width: "100%" }}
              onClick={() => {
                cookies.set("adminRoleId", item.roleId);
                loginRolePage(cookies.get("adminShorcuts"), item.roleId)
              }}
            >
              <span style={{ color: "black" }}>{item.name}</span>
              {roleIds === item.roleId ? (
                <span
                  style={{ color: "#999999", float: "right", fontSize: 12 }}
                >
                  设为默认登录角色
                </span>
              ) : (
                <a
                  style={{ float: "right", fontSize: 12 }}
                  onClick={e => changeDeRole(e, item.roleId)}
                >
                  设为默认登录角色
                </a>
              )}
            </a>
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default AlertFn2;
